import moment from "moment";

export const formatSmartDate = (dateString: any, showTime?: boolean) => {
    if (!dateString) return "—";
    
    // Safely convert to string
    const dateStr = String(dateString);
    
    let shouldShowTime = false;
    
    if (showTime !== undefined) {
        // Explicit override provided
        shouldShowTime = showTime;
    } else {
        // Smart heuristic
        const isTimestamp = typeof dateString === 'number' || (!isNaN(Number(dateString)) && dateStr.length > 10);
        const hasTimeComponent = isTimestamp || dateStr.includes('T') || dateStr.includes(' ') || dateStr.includes(':');
        const isMidnight = dateStr.includes('T00:00:00.000Z') || 
                           dateStr.includes('T00:00:00Z') || 
                           dateStr.includes('T00:00:00.000') || 
                           dateStr.endsWith(' 00:00:00');
                           
        shouldShowTime = hasTimeComponent && !isMidnight;
    }
    
    if (shouldShowTime) {
        return moment(dateString).format("DD/MM/YYYY hh:mm A");
    } else {
        return moment(dateString).format("DD/MM/YYYY");
    }
}
